export const capitalizeFirstLetter = (str: string) => {
  const allToLower = str.toLowerCase();
  return allToLower.charAt(0).toUpperCase() + allToLower.slice(1);
};
